//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AlbumItem from "@/components/xc_time/AlbumItem.vue";
import AlbumTags from "@/components/xc_time/AlbumTags.vue";
import { XTAlbum } from "@/models";
import { mapMutations } from "vuex";
import { log } from "util";
import TagNameMap from "@/config/xct-tag-name-map.js";

const getTagNameById = tagId => {
  if (tagId === "virtual-recommend-id") {
    return "精选";
  }

  return TagNameMap[tagId];
};

export default {
  data() {
    return {
      page: 1,
      perPage: 15,
      albumList: null,
      tagId: null,
      loading: false,
      tagName: ""
    };
  },

  metaInfo() {
    return {
      title: this.tagName + " · 中国传统文化音频平台",
      titleTemplate: null,
      meta: [{ name: "description", content: "中国传统文化音频平台" }]
    };
  },

  scrollBottom() {
    this.getXTAlbumsByTag();
  },

  created() {
    this.tagId = this.$route.params.tagId;
    this.tagName = getTagNameById(this.tagId);

    this.getXTAlbumsByTag();
  },

  methods: {
    ...mapMutations(["setCurrentAlbum"]),

    goToXCTAlbum(album) {
      this.setCurrentAlbum(album);
      this.$router.push({
        name: "xctAlbum",
        params: {
          albumId: album.id
        }
      });
    },

    getXTAlbumsByTag() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      // 判断本list是否是 推荐的list
      if (this.tagId !== "virtual-recommend-id") {
        XTAlbum.getXTAlbumsByTag(this.tagId, this.page, this.perPage).then(
          result => {
            if (!this.albumList) {
              this.albumList = result;
            } else if (this.albumList.length > 0) {
              this.albumList = this.albumList.concat(result);
            }

            this.loading = false;
            this.page += 1;
          }
        );
      } else {
        XTAlbum.getPublicRecommendXTAlbums(this.page, this.perPage).then(
          result => {
            if (!this.albumList) {
              this.albumList = result;
            } else if (this.albumList.length > 0) {
              this.albumList = this.albumList.concat(result);
            }

            this.loading = false;
            this.page += 1;
          }
        );
      }
    }
  },

  watch: {
    "$route.params": function(toParams, oldParams) {
      (this.page = 1),
        (this.perPage = 15),
        (this.albumList = null),
        (this.tagId = toParams.tagId);
      this.tagName = getTagNameById(toParams.tagId);
      this.loading = false;

      this.getXTAlbumsByTag();
    }
  },

  components: {
    AlbumItem,
    AlbumTags
  }
};



// WEBPACK FOOTER //
// ./src/pages/XCTimeAlbumList.vue